import { tryCatchHelper } from '../../helpers';
import {
  ACTIVO_TELEFONOS,
  ALL_TELEFONOS,
  LOADING_ALL_TELEFONOS,
} from './TelefonosReducer';
import {
  deleteTelefonosService,
  allTelefonosService,
  oneTelefonosService,
  saveTelefonosService,
} from './TelefonosService';

export const allTelefonosAction = async (dispatch, params) => {
  try {
    dispatch({ type: LOADING_ALL_TELEFONOS, payload: true });
    const res = await allTelefonosService(params);
    dispatch({ type: ALL_TELEFONOS, payload: res.data });
    dispatch({ type: LOADING_ALL_TELEFONOS, payload: false });
    return res.data;
  } catch (e) {
    dispatch({ type: LOADING_ALL_TELEFONOS, payload: false });
    tryCatchHelper(e);
    return false;
  }
};

export const saveTelefonosAction = async (
  { dispatch, notify },
  id,
  data,
  params,
) => {
  try {
    const res = await saveTelefonosService(id, data);
    notify(res.data.message);
    await allTelefonosAction(dispatch, params);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};

export const setActivoTelefonosAction = async (dispatch, data) => {
  dispatch({ type: ACTIVO_TELEFONOS, payload: data });
};

export const oneTelefonosAction = async (dispatch, id) => {
  try {
    const res = await oneTelefonosService(id);
    await setActivoTelefonosAction(dispatch, res.data);
    return res.data;
  } catch (e) {
    tryCatchHelper(e);
    return false;
  }
};

export const deleteTelefonosAction = async (
  { dispatch, notify },
  id,
  params,
) => {
  try {
    const res = await deleteTelefonosService(id);
    notify(res.data.message);
    await setActivoTelefonosAction(dispatch, null);
    await allTelefonosAction(dispatch, params);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};
